import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { BrutalButton } from "@/components/dashboard/BentoCard";
import { HexLogo } from "@/components/dashboard/Hex";

export function BillingSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      await refresh();
      if (attempts >= 6) return;
      setTimeout(poll, 1500);
    };
    poll();
  }, [refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-honeycomb px-4 py-12">
      <div className="max-w-lg w-full bg-white border-2 border-black shadow-brutal p-10 text-center">
        <div className="flex justify-center">
          <HexLogo size={64} />
        </div>
        <CheckCircle2 size={48} className="mx-auto text-emerald-600 mt-4" />
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-red-600">
          Trial started.
        </h1>
        <p className="mt-3 text-sm text-zinc-600">
          Your 3-day free trial is live. You won't be charged until it ends —
          cancel anytime from your account.
        </p>
        <p className="mt-3 text-[11px] font-mono-data text-zinc-500 uppercase tracking-widest break-all">
          Session {sessionId?.slice(0, 22)}…
        </p>
        <BrutalButton
          onClick={() => navigate("/properties")}
          className="mt-8 w-full justify-center py-3"
        >
          Enter the Ledger
        </BrutalButton>
        <Link to="/" className="block mt-4 text-xs text-zinc-500 underline">
          Or back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export function BillingCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-honeycomb px-4 py-12">
      <div className="max-w-lg w-full bg-white border-2 border-black shadow-brutal p-10 text-center">
        <XCircle size={48} className="mx-auto text-red-500" />
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight">
          Checkout canceled.
        </h1>
        <p className="mt-3 text-sm text-zinc-600">No worries — no card was charged.</p>
        <Link
          to="/pricing"
          className="mt-8 inline-block px-6 py-3 border-2 border-black bg-yellow-400 font-display font-semibold shadow-brutal-sm"
        >
          Back to Pricing
        </Link>
      </div>
    </div>
  );
}
